import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/230b03c6-c0a9-45fd-804f-9445c8c11b1d";
export const REGISTER_URL = "https://a.ntrk2.com/d23b6328-6acf-4ad6-b446-75ccd7d061b0";

export const LOGIN_URL_MAP = {
  "www-kk69.com": "https://a.ntrk2.com/0097f01a-47a6-4cad-bed3-3a6b5ff1ecad",
  "www-kk69.org": "https://a.ntrk2.com/0097f01a-47a6-4cad-bed3-3a6b5ff1ecad",
  "kk69login.com": "https://a.ntrk2.com/0097f01a-47a6-4cad-bed3-3a6b5ff1ecad",
  "www-6699kk.com": "https://a.ntrk2.com/0097f01a-47a6-4cad-bed3-3a6b5ff1ecad",
  "www-6699kk.cc": "https://a.ntrk2.com/0097f01a-47a6-4cad-bed3-3a6b5ff1ecad",
};

export const REGISTER_URL_MAP = {
  "www-kk69.com": "https://a.ntrk2.com/118d7587-384d-440c-8219-84c0c897a189",
  "www-kk69.org": "https://a.ntrk2.com/118d7587-384d-440c-8219-84c0c897a189",
  "kk69login.com": "https://a.ntrk2.com/118d7587-384d-440c-8219-84c0c897a189",
  "www-6699kk.com": "https://a.ntrk2.com/118d7587-384d-440c-8219-84c0c897a189",
  "www-6699kk.cc": "https://a.ntrk2.com/118d7587-384d-440c-8219-84c0c897a189",
};

export const FLOATING_BANNER_URL = "";

export * from "./codes";
export * from "./context";
export const DOWNLOAD_URL = "https://kk69.kzw2a.com/download?openExternalBrowser=1&id=qbs06h8adt6ymrr";
